/*eslint-disable*/
import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Label,
  FormGroup,
  Row,
  Input,
  Container,
  CardHeader,
  CardFooter,
  Button,
  Form, FormFeedback
} from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import axios from 'axios';
import SimpleHeader from "components/Headers/SimpleHeader.js";

export default function EditMerchantProjectMdr(props) {
  const token = localStorage.getItem("token");
  const [merchantPk, setMerchantPk] = useState("");
  const [transactionType, setTrasactionType] = useState("");
  const [transtypeId, setTranstypeId] = useState("");
  const [merchantFee, setMerchantFee] = useState("");
  const [merchantValue, setMerchantValue] = useState("");
  const [merchantStatus, setMerchantStatus] = useState(1);
  const [hostTypes, setHostTypes] = useState([]);
  const [types, setTypes] = useState([]);
  let history = useHistory();

  const [hostTypeError, setHostTypeError] = useState(null);
  const [cardTypeError, setCardTypeError] = useState(null);
  const [mdrValueError, setMdrValueError] = useState(null);
  const [mdrFeeError, setMdrFeeError] = useState(null);

  const validateForm = () => {
    let error = false;
    if (transactionType === "") {
      setHostTypeError("invalid");
      error = true;
    }
    if (transtypeId === "") {
      setCardTypeError("invalid");
      error = true;
    }
    if (merchantValue === "") {
      setMdrValueError("invalid");
      error = true;
    }
    if (merchantFee === "") {
      setMdrFeeError("invalid");
      error = true;
    }
    return error;
  };

  useEffect(() => {
    getAcquirerMdrById();
    getHostTypeList();
  }, []);

  const getAcquirerMdrById = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/merchantmdr/${props.match.params.id}`, {
        method: 'GET', // or 'PUT'
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(),
      })
      const data = await response.json();
      setMerchantPk(data.response_data.merchant_pk);
      setMerchantValue(data.response_data.merchant_mdr_val);
      setMerchantFee(data.response_data.merchant_mdr_fee);
      getTransTypeById(data.response_data.transtype_id);
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const getTransTypeById = async (transtype_id) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/transtype/${transtype_id}`, {
        method: 'GET', // or 'PUT'
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(),
      })
      let data = await response.json();
      setTrasactionType(data.response_data.transtype_name);
      getTypesList(data.response_data.transtype_name, transtype_id);
    } catch (error) {
      console.error('Error:', error);
    }
  }

  const getHostTypeList = () => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/transtypes`, {
      method: 'GET', // or 'PUT'
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(),
    })
      .then(response => response.json())
      .then(data => {
        const responseData = data.response_data;
        setHostTypes(responseData);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  const getTypesList = (hostType, transTypeId) => {
    const data = { transtype_name: hostType }
    fetch(`${process.env.REACT_APP_API_BASE_URL}/transtypes/list`, {
      method: 'POST', // or 'PUT'
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(data => {
        setTypes(data.response_data);
        setTranstypeId(transTypeId);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  function Update() {

    let body = {
      merchant_pk: parseInt(merchantPk),
      transtype_id: parseInt(transtypeId),
      merchant_mdr_val: parseFloat(merchantValue),
      merchant_mdr_fee: parseFloat(merchantFee),
      merchant_mdr_status: merchantStatus
    }
    axios.post(`${process.env.REACT_APP_API_BASE_URL}/merchantmdr/update/${props.match.params.id}`, body, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
      .then(function (response) {
        history.push("/admin/customers/daftar-project");
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) {
      Update();
    }
  }
  return (
    <>
      <SimpleHeader name="Edit Acquirer Mdr" parentName="Admin" />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardBody>
                <Form onSubmit={handleSubmit} >
                  <input type="hidden" name="merchant_pk" value={merchantPk} />
                  <input type="hidden" name="acqTransTypeStatus" value={merchantStatus} />
                  <CardHeader>
                    <h3>Edit  Mdr</h3>
                  </CardHeader>
                  <CardBody>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="acquirer_host_type"
                      >
                        Host Type
                        <span className="text-danger">*</span>
                      </Label>
                      <Input
                        disabled
                        id="exampleFormControlSelect3"
                        name="transaction_type"
                        type="select"
                        value={transactionType}
                        invalid={hostTypeError === "invalid"}
                        onChange={(e) => {
                          setTrasactionType(e.target.value);
                          if (e.target.value !== "") {
                            setHostTypeError("");
                          }
                          getTypesList(e.target.value);
                        }}
                      >
                        <option value="">Pilih Host Type</option>
                        {
                          hostTypes.map((hostType, key) => {
                            return <option key={key} value={hostType.transtype_name}>{hostType.transtype_name}</option>
                          })
                        }
                      </Input>
                      <FormFeedback>Host Type tidak boleh kosong</FormFeedback>
                    </FormGroup>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="encryption_type"
                      >
                        Card Type
                        <span className="text-danger">*</span>
                      </Label>
                      <Input
                        disabled
                        id="exampleFormControlSelect3"
                        name="transtype_id"
                        type="select"
                        value={transtypeId}
                        invalid={cardTypeError === "invalid"}
                        onChange={(e) => {
                          setTranstypeId(e.target.value);
                          if (e.target.value !== "") {
                            setCardTypeError("");
                          }
                        }}
                      >
                        <option value="">Pilih Card Type</option>
                        {
                          types.map((type, key) => {
                            return <option key={key} value={type.transtype_id}>{type.transtype_clsf}</option>
                          })
                        }
                      </Input>
                      <FormFeedback>Card Type tidak boleh kosong</FormFeedback>
                    </FormGroup>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="exampleFormControlInput1"
                      >
                        MDR Value (%)
                        <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        name="merchant_mdr_val"
                        placeholder="Masukan MDR Value"
                        value={merchantValue}
                        invalid={mdrValueError === "invalid"}
                        onChange={(e) => {
                          setMerchantValue(e.target.value);
                          if (e.target.value !== "") {
                            setMdrValueError("");
                          }
                        }}
                      />
                      <FormFeedback>Mdr Value tidak boleh kosong</FormFeedback>
                    </FormGroup>
                    <FormGroup>
                      <Label
                        className="form-control-label"
                        htmlFor="exampleFormControlInput1"
                      >
                        MDR Fee (Rp)
                        <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        name="merchant_mdr_val"
                        placeholder="Masukan MDR Fee"
                        value={merchantFee}
                        invalid={mdrFeeError === "invalid"}
                        onChange={(e) => {
                          setMerchantFee(e.target.value);
                          if (e.target.value !== "") {
                            setMdrFeeError("");
                          }
                        }}
                      />
                      <FormFeedback>Mdr Fee tidak boleh kosong</FormFeedback>
                    </FormGroup>
                  </CardBody>
                  <CardFooter>
                    <Button color="primary" type="submit">
                      Simpan
                    </Button>
                    <Link className="btn btn-info" to="/admin/customers/daftar-project">
                      Kembali
                    </Link>
                  </CardFooter>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}
